export default __webpack_public_path__ + "static/media/Header-14.684c4f21.jpg";